module.exports = __webpack_public_path__ + "assets/img/ActivityCreation.b486e126.png";